import { render, staticRenderFns } from "./Linkago.vue?vue&type=template&id=6f8a6da8&scoped=true&"
import script from "./Linkago.vue?vue&type=script&lang=js&"
export * from "./Linkago.vue?vue&type=script&lang=js&"
import style0 from "./Linkago.vue?vue&type=style&index=0&id=6f8a6da8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8a6da8",
  null
  
)

export default component.exports